import { Cookies } from 'react-cookie';

export interface AuthResult {
	access_token: string;
	id_token: string;
	refresh_token: string;
	expires_in: number;
	token_type: string;
}

export function setCookies(authResult: AuthResult, _hostname: string, protocol: string, cookieDomain?: string) {
	const isSecure = protocol === 'https:';
	const cookies = new Cookies();

	cookies.set('aws_cognito_access_token', authResult.access_token, {
		path: '/',
		maxAge: authResult.expires_in,
		domain: cookieDomain,
		secure: isSecure,
	});

	cookies.set('aws_cognito_expires_in', authResult.expires_in, {
		path: '/',
		maxAge: authResult.expires_in,
		domain: cookieDomain,
		secure: isSecure,
	});

	cookies.set('aws_cognito_id_token', authResult.id_token, {
		path: '/',
		maxAge: authResult.expires_in,
		domain: cookieDomain,
		secure: isSecure,
	});

	cookies.set('aws_cognito_refresh_token', authResult.refresh_token, {
		path: '/',
		maxAge: authResult.expires_in,
		domain: cookieDomain,
		secure: isSecure,
	});

	cookies.set('aws_cognito_token_type', authResult.token_type, {
		path: '/',
		maxAge: authResult.expires_in,
		domain: cookieDomain,
		secure: isSecure,
	});
}
